(ns minorodata.unleash.events
  (:require [applied-science.js-interop :as jsi]
            [minorodata.app.handlers :refer [reg-event-fx reg-fx reg-event-db dispatch]]
            [minorodata.unleash.core :refer [unleash dispatch-toggles-loaded!]]
            [re-frame.core :as re-frame]))


(defn initialize-app []
  (re-frame/dispatch [:app.events/initialize]))


(reg-event-fx
 :unleash/start
 (fn [_ _]
   (-> (.start unleash)
       (.then initialize-app)
       (.catch initialize-app))
   nil))


(defonce ^:private context-version (atom 0))


(reg-fx
 :unleash/update-context
 (fn [context]
   (let [old-context (jsi/call unleash :getContext)
         new-context (jsi/call js/Object :assign old-context (clj->js context))
         version     (swap! context-version inc)]
     (.then (jsi/call unleash :updateContext new-context)
            #(when (= version @context-version)
               (dispatch-toggles-loaded! unleash)))

     ;; Add a bit of a timeout so that unleash has time to fetch latest feature
     ;; flags
     (js/setTimeout (fn [] (dispatch [:unleash/update-timestamp (js/Date.now)]))
                    100))
   nil))


(reg-event-db
 :unleash/update-timestamp
 (fn [db [timestamp]]
   (assoc db :unleash/timestamp timestamp)))


(reg-event-db
 :unleash/toggles-loaded
 (fn [db [timestamp user-id]]
   (assoc db
          :unleash/timestamp timestamp
          :unleash/loaded-user-id user-id)))
